export default {"src":"/_next/static/media/coldcut.03bdfcb3.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};